export default __webpack_public_path__ + "static/media/MG.929451ed.svg";